// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7833":"7a2d4c2d","9195":"89ba7329","9453":"89ba7329"}[chunkId] + ".chunk.css";
};